module.exports = __webpack_public_path__ + "static/img/bg_img.0b9b725.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/VXImage/bg_img.svg
// module id = 9MCn
// module chunks = 0